export default "__VITE_ASSET__B73sr9lM__"